<template>
  <div class="hello">
    <br />
    <section ref="print">
      <!--startprint-->
      <div id="PrintArea" class="printOrder-data">
        <div class="recipeBG">
          <!--
        <img src="../../../static/images/Recipe-XianCi.png" class="recipeBG" />
          -->
          <img :src="getRecipePic(form.doctorID)" class="recipeBG" />

          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <p class="typeItemName">{{ form.name }}</p>
            <p class="typeItemGender">{{ form.gender }}</p>
            <p class="typeItemAge">{{ form.age }}</p>
            <p class="typeItemDateY">{{ form.dateY }}</p>
            <p class="typeItemDateM">{{ form.dateM }}</p>
            <p class="typeItemDateD">{{ form.dateD }}</p>
            <p class="typeItemSickDetail">{{ form.sickDetail }}</p>
            <div v-if="form.drugDetail.length<5">
            <div class="typeItemDrugDetail">
              <div v-for="item in form.drugDetail " :key="item">
                <p style="font-size:14px">{{item.drug_name}}</p>
                <p style="font-size:13px;position:relative; top:-8px">{{item.drug_useway}}</p>
              </div>
            </div>
            </div>
            <div v-else>
            <div class="typeItemDrugDetail">
              <div v-for="(item,i) in form.drugDetail " :key="item" style="position:relative">
                <p v-if="i<8" style="font-size:9px">{{item.drug_name}}</p>
                <p v-if="i<8" style="font-size:9px; position:relative; top:-8px " >{{item.drug_useway}}</p>
              </div>
            </div> 

                  
            <div class="typeItemDrugDetail2">
              <div v-for="(item,i) in form.drugDetail " :key="item" style="position:relative">
                <p v-if="i>=8" style="font-size:9px">{{item.drug_name}}</p>
                <p v-if="i>=8" style="font-size:9px; position:relative; top:-8px " >{{item.drug_useway}}</p>
              </div>
            </div> 

            </div>
            <img id="codeimg" class="qrimg" :src="getQRURL(form.recipeIDnum)" width="55" height="55"/>
            <img class="typeItemDrPic" :src="getDoctorSignPic(form.doctorID)" />
             <!--

            <img class="typeItemPhPic" :src="getDoctorSignPic(form.reviewerID)" />
            -->
            <p class="typeItemRecipeID">{{ form.recipeIDField }}</p>
          </el-form>
        </div>
      </div>
    </section>
    <!--endprint-->
    <el-form ref="form" :model="form" :rules="rules" label-width="70px" style="position:relative">
      <!--
      <el-form-item>
        <el-button type="primary" @click="doPrint('form')">打印处方</el-button>
      </el-form-item>
      -->
      <table>
          <tr>
            <td>
              <el-form-item>
                <el-button type="primary" @click="printSection()">打印处方</el-button>
              </el-form-item>
            </td>
            <td>
              <el-form-item>
                <el-button @click="printXiaoPiao()">处方小票</el-button>
              </el-form-item>
            </td>
          </tr>
      </table>
      

      <!--
      <el-button type="primary" @click="doPrint('form')">打印</el-button>
      -->
    </el-form>
  </div>
</template>

<script>
import qs from 'qs';
import {getLodop} from '../../../plugins/LodopFuncs';
export default {
  name: "RecipePrint",

  data() {
    return {
      /*
      note: {
        backgroundImage:
          "url(" + require("../../../static/images/Recipe-XianCi.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "200px auto",
        marginTop: "5px"
      }, */
      imgSource: require("../../../static/images/Recipe-XianCi.png"),
      RecipeRequestApi: "https://yc.suyizaixian.com:30005/requestMyRecipeDetail",
      qrApi:"https://yc.suyizaixian.com:30005/qrcode/txt?text=",
      qrURL:"https%253A%252F%252Fyc.suyizaixian.com%252F%2523%252FQRLink%253Fid%253D",
      //qrURL:"http%253A%252F%252Flocalhost%253A8080%252F%2523%252FQRLink%253Fid%253D",
      //doctorSignPic :require("../../../static/images/Sign_2.png"),
      //phSignPic : require("../../../static/images/Sign_3.png"),
      form: {
        name: "",
        gender: "",
        age: "",
        dateY: "",
        dateM: "",
        dateD: "",
        sickDetail: "",
        drugDetail: [],
        drugDetail2: [],
        recipeIDField: "",
        recipeIDnum: "",
        doctorID: "",
        reviewerID: "",
      },
      useWays: [
        { value: 1, label: "口服" },
        { value: 2, label: "外用" },
        { value: 3, label: "外敷" },
        { value: 4, label: "注射" },
        { value: 5, label: "其他" }
      ],

      DrugUnit: [
        { value: 1, label: "粒" },
        { value: 2, label: "片" },
        { value: 3, label: "袋" },
        { value: 4, label: "包" },
        { value: 5, label: "滴" },
        { value: 6, label: "毫升" },
        { value: 7, label: "克" },
        { value: 8, label: "毫克" },
        { value: 9, label: "颗" },
        { value: 10, label: "喷" },
        { value: 11, label: "揿" },
        { value: 12, label: "丸" },
        { value: 13, label: "贴" },
        { value: 14, label: "枚" },
        { value: 15, label: "支" },
        { value: 16, label: "IU" }
      ],

      rules: {}
    };
  },
  props: {
    msg: String
  },
  methods: {
    printXiaoPiao(){
      let LODOP = getLodop();
      LODOP.PRINT_INIT("");
      LODOP.ADD_PRINT_TEXT(20,10,180,15,"No:"+this.form.recipeIDField);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.ADD_PRINT_TEXT(50,10,180,50,this.getRecipeName(this.form.doctorID));
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      let name = "姓名: "+ this.form.name
      LODOP.ADD_PRINT_TEXT(100,10,180,15,name);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      let gender = "性别: "+ this.form.gender
      LODOP.ADD_PRINT_TEXT(115,10,180,15,gender);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      let age = "年龄: "+ this.form.age
      LODOP.ADD_PRINT_TEXT(130,10,180,15,age);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      let dateFull = "日期: "+ this.form.dateY+"-"+ this.form.dateM+"-"+ this.form.dateD
      LODOP.ADD_PRINT_TEXT(145,10,180,15,dateFull);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.ADD_PRINT_TEXT(160,10,180,15,"临床诊断: ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.ADD_PRINT_TEXT(175,10,180,15,this.form.sickDetail);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.ADD_PRINT_TEXT(190,10,180,15,"Rp");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
      let count =0;
      let top=230
      this.form.drugDetail2.forEach(item => { 
        top=230+40*count
        LODOP.ADD_PRINT_TEXT(top,10,180,15,item.drug_name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
        top=230+40*count+20
        LODOP.ADD_PRINT_TEXT(top,10,180,15,item.drug_useway);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",7); 
        count++;
      });
      top=230+40*count+10
      let top2=top+10
      LODOP.ADD_PRINT_TEXT(top2,10,160,15,"医师：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      top2=top2+15
      LODOP.ADD_PRINT_IMAGE(top2,30,100,50,"<img border='0' src='"+this.getDoctorSignPic(this.form.doctorID)+"' width=500 height=500 />");
      LODOP.SET_PRINT_STYLEA(0,"Stretch",1);//(可变形)扩展缩放模式
      top2=top2+50
      LODOP.ADD_PRINT_TEXT(top2,10,160,15,"调配：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      top2=top2+60
      LODOP.ADD_PRINT_TEXT(top2,10,160,15,"审核：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      top2=top2+60
      LODOP.ADD_PRINT_TEXT(top2,10,160,15,"--------------------");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      top2=top2+20
      LODOP.ADD_PRINT_IMAGE(top2,20,100,100,"<img border='0' src='"+this.getQRURL(this.form.recipeIDnum)+"' width=500 height=500 />");
      LODOP.SET_PRINT_STYLEA(0,"Stretch",1);//(可变形)扩展缩放模式

      LODOP.PREVIEW();
    },
    printSection() {
      this.$print(this.$refs.print);
    },
    getDoctorSignPic(num) {
      return require("../../../static/images/Sign_" + num + ".png");
    },
    getRecipePic(num){
      if(num==364){
        return require("../../../static/images/Recipe-364RunBo.png");
      } else if(num==365){
        return require("../../../static/images/Recipe-365DingKang.png");
      } else if(num==367){
        return require("../../../static/images/Recipe-365DingKang.png");
      } else if(num==368){
        return require("../../../static/images/Recipe-365DingKang.png");
      } else{
        return require("../../../static/images/Recipe-366JieYang.png");
      }
    },
    doPrint() {
      var newstr = document.getElementsByClassName("printOrder-data")[0]
        .innerHTML;
      //console.log(newstr);
      document.body.innerHTML = newstr;

      window.print();
      // 重新加载页面，以刷新数据
      window.location.reload();
    },
    getRecipeName(num){  
      var recipeName=""
      if(num==364){
        recipeName="润博互联网医院";
        return recipeName;
      } else if(num==365){
        recipeName="鼎康慈桦互联网医院处方笺";
        return recipeName;
      } else{
        recipeName="揭阳市榕城区人民医院莲藕互联网医院处方笺";
        return recipeName;
      }
    },
    onSubmit(formName) {
      alert("back page", formName);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    PrefixInteger(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },

    getQRURL(num){
      let qrURL= this.qrApi+this.qrURL+ num;
      //console.log("qrURL");
      //console.log(qrURL);
      return qrURL;
    }

  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var _this = this;
    _this.form.recipeIDnum = sessionStorage.getItem("PrintRecipeID");
    _this.form.recipeIDField = _this.PrefixInteger(Number(_this.form.recipeIDnum), 8);
    let datas = {
      recipeID: _this.form.recipeIDnum,
      authToken: sessionStorage.getItem("authToken")
       };
       //console.log(datas);
    _this.axios
      .post(_this.RecipeRequestApi, qs.stringify(datas))
      .then(response => {
        let res = response.data;
        //console.log(res);
        if (res.data.result == "success") {
          //console.log(res.data);
          _this.form.name = res.data.userInfo.name;
          _this.form.gender = res.data.userInfo.sex == "1" ? "男" : "女";
          _this.form.age = res.data.userInfo.age;
          _this.form.dateY = res.data.userSickInfo.recipeTime.split(/[- : T]/)[0];
          _this.form.dateM = res.data.userSickInfo.recipeTime.split(
            /[- : T]/
          )[1];
          _this.form.dateD = res.data.userSickInfo.recipeTime.split(
            /[- : T]/
          )[2];
          _this.form.sickDetail = res.data.userSickInfo.sickDetail;
          _this.form.doctorID = res.data.userSickInfo.doctorID;
          _this.form.reviewerID = res.data.userSickInfo.reviewerID;
          let count = 1;
          res.data.drugInfo.forEach(eachDrug => {
            let useWaystr = "";
            let unitStr = "";
            _this.useWays.forEach(eachUseWay => {
              if (eachUseWay.value == eachDrug.useway) {
                useWaystr = eachUseWay.label;
              }
            });

            _this.DrugUnit.forEach(eachUnit => {
              if (eachUnit.value == eachDrug.unit) {
                unitStr = eachUnit.label;
              }
            });
            let thisdrugName;
            if(eachDrug.volumn==2){
              thisdrugName = count + "." + eachDrug.drug_name+"  " + eachDrug.specification + " " +eachDrug.quantity+"剂" ;
            }else{
              thisdrugName = count + "." + eachDrug.drug_name+"  " + eachDrug.specification + " *" +eachDrug.quantity ;
            }
            let thisdrugUseWay ="用法用量: "+ useWaystr + "   每日" + eachDrug.frequency +"次   每次" +eachDrug.numPerTime +unitStr;
            let thisdrugUseWay2 ="用法用量:"+ useWaystr + " 每日" + eachDrug.frequency +"次 每次" +eachDrug.numPerTime +unitStr;
            count++;
            _this.form.drugDetail.push({
              drug_name: thisdrugName,
              drug_useway: thisdrugUseWay
            });
            _this.form.drugDetail2.push({
              drug_name: thisdrugName,
              drug_useway: thisdrugUseWay2
            });
          });
        } else {
          alert(res.data.err.code);
        }
      }).catch((e) => { alert(e+"，登录超时，请重新登录");});
  }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.recipeBG {
  width: 450px;
  height: 645px;
  position: relative;
}
.typeItemName {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 77px;
  top: 120px;
  /* top: 106px; */
}

.typeItemGender {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 180px;
  top: 120px;
  /* top: 106px; */
}

.typeItemAge {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 315px;
  top: 122px;
  /* top: 96px; */
}
.typeItemDateY {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 308px;
  top: 144px;
  /*
  left: 40px;
  top: 120px;
  */
}

.typeItemDateM {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 358px;
  top: 144px;  
    /*
  left: 105px;
  top: 120px;
    */
}

.typeItemDateD {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 391px;
  top: 144px; 
  /*
  left: 180px;
  top: 120px;
  */
}

.typeItemSickDetail {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 80px;
  top: 141px;
  /*
  left: 115px;
  top: 145px;
  */
}

.typeItemDrugDetail {
  color: black;
  font-size: 11px;
  position: absolute;
  left: 70px;
  top: 172px;
}

.typeItemDrugDetail2 {
  color: black;
  font-size: 11px;
  position: absolute;
  left: 240px;
  top: 172px;
}

.typeItemDrPic {
  position: absolute;
  left: 80px;
  top: 503px;
  height: 30px;
  /*
  left: 80px;
  top: 570px;
  */
}

.qrimg2{
    position: absolute;
    left: 115px;
    top: 140px;
}

.qrimg{
    position: absolute;
  
    left: 30px;
    top: 40px;

  /*
    left: 320px;
    top: 512px;
      */
}

.typeItemPhPic {
  position: absolute;
  left: 280px;
  top: 560px;
  height: 30px;
}

.typeItemRecipeID {
  color: red;
  font-size: 14px;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  font-weight: bold;
  position: absolute;
  /*
  left: 70px;
  top: 533px;  */
  left: 300px;
  top: 75px;

}

.noprint {
  display: none;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

